import { render, staticRenderFns } from "./reminderCreatePopup.vue?vue&type=template&id=1b49800a&scoped=true&"
import script from "./reminderCreatePopup.vue?vue&type=script&lang=js&"
export * from "./reminderCreatePopup.vue?vue&type=script&lang=js&"
import style0 from "./reminderCreatePopup.vue?vue&type=style&index=0&id=1b49800a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49800a",
  null
  
)

export default component.exports